<script setup>
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <div
    data-slot="drawer-header"
    :class="cn('flex flex-col gap-1.5 p-4', props.class)"
  >
    <slot />
  </div>
</template>
